import { useSelector } from 'react-redux';
import { isRequiredFeatureEnabled } from 'src/components/auth';
import { FeatureFlag, State } from 'src/types';

export const useIsFeatureEnabled = (feature: FeatureFlag) => {
  const features = useSelector(({ features }: State) => features);
  return isRequiredFeatureEnabled(features, feature);
};
